import Reveal from "@/components/Reveal";
import { Package, Search, Wrench } from "lucide-react";

const steps = [
  { icon: Package, step: "01", title: "Drop Off", desc: "Bring your device to our Atlanta location or schedule a remote session." },
  { icon: Search, step: "02", title: "Diagnosis", desc: "Our experts run a thorough diagnostic — often with a free 15-minute assessment." },
  { icon: Wrench, step: "03", title: "Fix & Deliver", desc: "We repair your device and get it back to you fast, with a satisfaction guarantee." },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-primary text-primary-foreground">
      <div className="container">
        <div className="text-center mb-14">
          <p className="text-primary-foreground font-semibold text-sm uppercase tracking-widest mb-3">Simple Process</p>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold">
            How It Works
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.1} className="text-center">
              <div className="mx-auto h-16 w-16 rounded-2xl bg-primary-foreground/10 flex items-center justify-center mb-5">
                <s.icon className="h-7 w-7" />
              </div>
              <span className="text-primary-foreground font-display font-extrabold text-sm">{s.step}</span>
              <h3 className="font-display font-bold text-xl mt-2 mb-3">{s.title}</h3>
              <p className="text-primary-foreground text-sm leading-relaxed max-w-xs mx-auto">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
